import { FormLabel, FormControl, FormHelperText, Select as ChakraSelect } from "@chakra-ui/react";
import type { SelectProps } from "./Select.d";

const Select = ({ errors, name, label, placeholder, register, options, disabled = false, helperText }: SelectProps) => (
  <FormControl isInvalid={errors[name]} isDisabled={disabled} id={name}>
    {label && (
      <FormLabel htmlFor={name} fontWeight="semibold" mb={2}>
        {label}
      </FormLabel>
    )}
    <ChakraSelect h="48px" name={name} placeholder={placeholder} ref={register}>
      {options &&
        options.map((elem) => (
          <option key={elem.value} value={elem.value}>
            {elem.label}
          </option>
        ))}
    </ChakraSelect>
    {helperText && <FormHelperText color="greyscale.500">{helperText}</FormHelperText>}
  </FormControl>
);

export default Select;
